<template>
    <li class="flex gap-2.5 items-start">
        <span class="flex items-center justify-center pt-0.5 shrink-0 w-5">
            <BaseSvg
                name="PushPin"
                aria-hidden="true"
                class="fill-v2-gray-70 rotate-45 size-[18.25px] dark:fill-v2-gray-90"
            />
        </span>
        <span>
            Added to <button
            @click.prevent="openTray(computedTray, true)"
            class="text-v2-gray-20 underline underline-offset-4 dark:text-v2-gray-130 print:no-underline"
        >
            {{ computedTray?.name }}
        </button>
        </span>
    </li>
</template>

<script setup>
import {usePinsDrawer} from "@/Composables";
import {computed} from "vue";

const props = defineProps(['tray']);
const { openTray, drawer } = usePinsDrawer();

const computedTray = computed(() => drawer.value.trays.find(t => t.name === props.tray));
// icon can be CreateNewFolder or PushPin depending on if it PINNED or ADDED TO PROJECT
// should start with Added to project, Added to tray, Added to Favorites
</script>
